export enum ProductPresenceDataType {
  Y_N = "Y_N",
  ONE_ZERO = "ONE_ZERO",
}

export enum VendorPresenceDataType {
  PRODUCT_COUNT = "PRODUCT_COUNT",
  Y_N = "Y_N",
  ONE_ZERO = "ONE_ZERO",
}

export enum ChooseColumnDialogPhases {
  CHOOSE_TYPE = "CHOOSE_TYPE",
  PRODUCTS = "PRODUCTS",
  VENDORS = "VENDORS",
}

export interface ProductPresenceColumn {
  dataType: ProductPresenceDataType;
  name?: string;
  ids: number[];
}

export interface VendorPresenceColumn {
  dataType: VendorPresenceDataType;
  name?: string;
  ids: number[];
}

export interface CustomColumn {
  id: string;
  type: "product" | "vendor";
  name: string;
  dataType: ProductPresenceDataType | VendorPresenceDataType;
  ids: number[];
}

export interface Selectable {
  isSelected: boolean;
  phase: ChooseColumnDialogPhases;
}

export type SelectableCustomColumn = CustomColumn & Selectable;

// Default values
export const DEFAULT_PRODUCT_DATA_TYPE = ProductPresenceDataType.Y_N;
export const DEFAULT_VENDOR_DATA_TYPE = VendorPresenceDataType.PRODUCT_COUNT;
export const DEFAULT_PRODUCT_COLUMN_NAME = "Products";
export const DEFAULT_VENDOR_COLUMN_NAME = "Vendors";

// Local storage keys
export const CUSTOM_COLUMN_LOCAL_STORAGE_KEY = "exportCustomColumns";
export const CLOUD_MATURITY_ENABLED_LOCAL_STORAGE_KEY = "cloudMaturityEnabled";
